module.exports = __webpack_public_path__ + "img/34.1d70ecd9.jpg";